import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=3b5c2e77&scoped=true&"
var script = {}
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=3b5c2e77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5c2e77",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
